var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrencytwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Currency 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31 14.7984C31 6.9042 24.2816 0.5 16 0.5C7.71842 0.5 1 6.9042 1 14.7984V19.2009H31V14.7984Z",
    fill: "url(#paint0_linear_8056_78212)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 4.90242V0.5",
    stroke: "#1A5B48",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.70703 11.0059V6.60352",
    stroke: "#1A5B48",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.293 11.0059V6.60352",
    stroke: "#1A5B48",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.85742 6.15173V1.75684",
    stroke: "#1A5B48",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.1426 6.15173V1.75684",
    stroke: "#1A5B48",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M31 14.7984C31 6.9042 24.2816 0.5 16 0.5C7.71842 0.5 1 6.9042 1 14.7984V19.2009H31V14.7984Z",
    stroke: "#1A5B48",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16 33.5002C24.2843 33.5002 31 27.0986 31 19.2018C31 11.305 24.2843 4.90332 16 4.90332C7.71573 4.90332 1 11.305 1 19.2018C1 27.0986 7.71573 33.5002 16 33.5002Z",
    fill: "#216C58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.2,
    d: "M29.067 12.1949L10.6644 32.5514C12.3223 33.1534 14.1144 33.4996 15.9933 33.4996C16.4986 33.4996 16.996 33.477 17.4854 33.4243L30.9539 18.5163C30.8433 16.221 30.1723 14.0763 29.0591 12.1874L29.067 12.1949ZM20.1775 5.47461L2.38281 25.1613C3.21965 26.8997 4.41176 28.4424 5.87229 29.7218L25.4275 8.08596C23.896 6.90445 22.1197 6.00892 20.1775 5.47461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16 33.5002C24.2843 33.5002 31 27.0986 31 19.2018C31 11.305 24.2843 4.90332 16 4.90332C7.71573 4.90332 1 11.305 1 19.2018C1 27.0986 7.71573 33.5002 16 33.5002Z",
    stroke: "#1A5B48",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.5,
    d: "M4.73438 21.5488C5.87122 26.4856 10.4896 30.1956 16.0002 30.1956C21.5107 30.1956 26.1291 26.4856 27.266 21.5488",
    stroke: "#71BCA4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.5,
    d: "M27.266 16.845C26.1291 11.9083 21.5107 8.19824 16.0002 8.19824C10.4896 8.19824 5.87122 11.9083 4.73438 16.845",
    stroke: "#71BCA4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M11.4222 10.9447H21.259C21.5511 10.9447 21.78 10.7339 21.78 10.448V10.1695C21.78 9.95882 21.559 9.67285 21.259 9.67285H11.4222C11.2011 9.67285 10.9011 9.9513 10.9011 10.1695V10.448C10.9011 10.7264 11.1222 10.9447 11.4222 10.9447ZM17.9274 12.1788V11.4338H16.5932V12.0509C17.0432 12.066 17.4932 12.1036 17.9274 12.1788ZM15.859 12.0434V11.4338H14.5248V12.1563C14.959 12.0885 15.4011 12.0509 15.859 12.0434ZM14.5248 28.2157C14.5248 28.4941 14.7458 28.7124 15.0458 28.7124H15.3379C15.63 28.7124 15.859 28.5017 15.859 28.2157V27.8846C15.4011 27.877 14.959 27.8394 14.5248 27.7867V28.2082V28.2157ZM16.5932 28.2157C16.5932 28.4941 16.8143 28.7124 17.1143 28.7124H17.4064C17.6985 28.7124 17.9274 28.5017 17.9274 28.2157V27.7943C17.5248 27.8469 17.0827 27.877 16.5932 27.8846V28.2157ZM17.9274 22.3608C17.7853 22.2856 17.6353 22.2179 17.4774 22.1577C17.2643 22.0749 16.9643 21.9846 16.5932 21.8867V24.0616C16.9169 24.0315 17.1932 23.9788 17.4064 23.9036C17.6037 23.8358 17.7695 23.7531 17.9274 23.6552V22.3608ZM16.5932 17.981L17.6353 18.1767C17.73 18.1917 17.8327 18.2218 17.9274 18.2444V16.2501C17.8722 16.205 17.8169 16.1598 17.7537 16.1222C17.4695 15.9416 17.0827 15.8362 16.5932 15.7986V17.9885V17.981ZM22.009 21.5029C21.7406 21.0514 21.3932 20.6601 20.9906 20.3365C20.5879 20.0129 20.0116 19.742 19.459 19.4711C18.8511 19.2528 18.1248 19.0571 17.4774 18.9367L16.0011 18.6583C15.6222 18.583 15.3222 18.5153 15.0222 18.4401C14.7143 18.3648 14.3748 18.2218 14.0827 18.0337C13.83 17.8756 13.6643 17.7176 13.5064 17.5671L13.4353 17.4843C13.3406 17.3112 13.23 17.1005 13.23 16.7995C13.23 16.5286 13.3169 16.1297 13.5695 15.8889C13.9011 15.5728 14.1695 15.3998 14.5958 15.2417C15.0222 15.0762 15.5195 15.0009 16.1511 15.0009C17.0274 15.0009 17.7064 15.1589 18.2274 15.4901C18.5432 15.7083 18.8511 15.9792 19.0485 16.4458C19.1906 16.7092 19.3169 16.7694 19.4827 16.7694H21.8511C21.9616 16.7694 22.0643 16.7242 22.1274 16.649C22.1827 16.5888 22.2064 16.5211 22.1906 16.4458C22.1274 15.8588 21.8985 15.3546 21.4485 14.7827C21.0143 14.1882 20.3195 13.7216 19.3327 13.3603C18.3537 12.9991 17.2879 12.8185 16.1511 12.8185C15.0143 12.8185 13.9406 12.9991 12.9695 13.3603C12.1248 13.6689 11.3432 14.1806 10.759 14.8052C10.23 15.4374 9.97742 16.1373 9.97742 16.9425C9.97742 17.9584 10.3722 18.7561 11.1458 19.313C12.0379 19.9527 13.1274 20.4042 14.3906 20.6526L16.2379 21.0063C16.9406 21.1718 17.43 21.3148 17.7853 21.4503C18.1485 21.5857 18.5195 21.7513 18.8116 22.0297C19.08 22.2856 19.23 22.6017 19.23 22.9403C19.23 23.3166 19.1195 23.6101 18.8511 23.9487C18.4958 24.2874 18.1327 24.5056 17.6906 24.6486C17.2958 24.7991 16.7353 24.8819 16.08 24.8819C15.4248 24.8819 14.88 24.8066 14.3985 24.6486C13.8537 24.4755 13.4274 24.2121 13.1669 23.881C13.0011 23.6402 12.8274 23.3994 12.7406 23.136C12.709 22.9855 12.6143 22.7672 12.3143 22.7672H9.94584C9.83531 22.7672 9.73268 22.8124 9.66952 22.8876C9.61426 22.9478 9.59058 23.0156 9.60636 23.0908C9.67742 23.8659 9.93794 24.5207 10.4116 25.1001C10.98 25.7774 11.7379 26.2741 12.6695 26.5977C13.7353 26.9589 14.88 27.1395 16.159 27.1395C17.6432 27.1395 18.7169 26.974 19.5379 26.6128C20.5327 26.2741 21.2037 25.8226 21.6695 25.1904C22.1669 24.5131 22.4116 23.7982 22.4116 23.0156C22.4116 22.4511 22.2774 21.9469 22.0248 21.518L22.009 21.5029ZM14.5248 17.3865C14.7458 17.5219 14.9906 17.6348 15.2116 17.6875C15.4169 17.7327 15.63 17.7853 15.8511 17.8305V15.776C15.4722 15.7986 15.1564 15.8513 14.8958 15.9491C14.7458 16.0093 14.6353 16.062 14.5248 16.1297V17.379V17.3865ZM15.859 21.7212L14.5248 21.4653V23.8584C14.5643 23.8735 14.6116 23.8885 14.6511 23.9036C14.9985 24.0089 15.409 24.0616 15.8511 24.0842V21.7212H15.859Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8056_78212",
    x1: 1,
    y1: 9.84667,
    x2: 31,
    y2: 9.84667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#449E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#216C58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencytwo);
export default __webpack_public_path__ + "static/media/Currencytwo.91e0c08e0095d220af26104ebb80528c.svg";
export { ForwardRef as ReactComponent };